import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { paths } from 'src/paths';
import { Permissions, useScopeChecker } from 'src/rbac';
import { getEpisodeOfCare } from 'src/redux/actions/patientEpisodeOfCare';
import { getScreening } from 'src/redux/actions/patientScreening';
import { EpisodeOfCareTable } from './episode-of-care-table';
import { FacilityStayTable } from './facility-stay-table';
import { ScreeningsTable } from './screening-table';

type Props = {
  patientId: string;
};
const { patients, editPatient } = paths;

export const formatContactNumber = (value: string) => {
  if (value === null) {
    return {
      formattedValue: '',
      cleanedValue: '',
    };
  }

  const cleanedValue = value?.replace(/[^\d+]/g, '');

  const pattern = /^(\+\d{1,3})?(\d{3})?(\d{3})(\d{4})$/;

  const formattedValue = cleanedValue?.replace(pattern, (match, p1, p2, p3, p4) => {
    if (p2 && p3) {
      if (p1) {
        return `${p1} (${p2})-${p3}-${p4}`;
      } else {
        return `(${p2})-${p3}-${p4}`;
      }
    } else {
      return cleanedValue;
    }
  });

  return {
    formattedValue,
    cleanedValue,
  };
};

function PatientInfo({ patientId }: Props) {
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const screeningData = useSelector((state: any) => state?.getScreeningReducer?.response);
  const episodeOfCareData = useSelector((state: any) => state?.getEpisodeOfCare?.response);
  const facilityStayData = useSelector((state: any) => state?.getAllFacilitiesStaysReducer);
  const patientDataLoader = useSelector((state: any) => state.getSinglePatientReducer);
  const has = useScopeChecker();

  const patientDob = patientData?.dateOfBirth && patientData?.dateOfBirth?.split('T')?.at(0);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getScreening({ patientId }));
  }, []);

  useEffect(() => {
    dispatch(
      getEpisodeOfCare({
        patientId,
      })
    );
  }, []);

  return (
    <>

      {/* Epidose of care */}
      {has(Permissions.READ_EOC) && (
        <EpisodeOfCareTable episodeOfCareData={episodeOfCareData?.content} />
      )}

      {/* Screenings Table */}
      {has(Permissions.READ_SCREENING) && (
        <ScreeningsTable screeningData={screeningData?.content} />
      )}

      {/* Facility stay table */}
      <FacilityStayTable
        patientId={patientId}
        patientData={patientData}
      />
    </>
  );
}

export default PatientInfo;
